// valueKey wskazuje który kolumn bazy danych czytamy/zapisujemy
// type determinuje jaki input renderujemy w GUI

export const PARAM_GROUPS = [
  {
    label: "Firma",
    params: [
      { id: "CompanyName", type: "text", valueKey: "valueChar" },
      { id: "CompanyNameForEmails", type: "text", valueKey: "valueChar" },
      { id: "CompanyEmail", type: "email", valueKey: "valueChar" },
      { id: "CompanyPhone", type: "text", valueKey: "valueChar" },
      { id: "CompanyStreet", type: "text", valueKey: "valueChar" },
      { id: "CompanyCity", type: "text", valueKey: "valueChar" },
      { id: "CompanyZipCode", type: "text", valueKey: "valueChar" },
      { id: "CompanyFacebook", type: "url", valueKey: "valueChar" },
      { id: "CompanyInstagram", type: "url", valueKey: "valueChar" },
      { id: "CompanyLinkedIn", type: "url", valueKey: "valueChar" },
      { id: "CompanyTwitter", type: "url", valueKey: "valueChar" },
      { id: "CompanyYoutube", type: "url", valueKey: "valueChar" },
    ],
  },
  {
    label: "Logo",
    params: [
      { id: "LogoSourceWhiteMode", type: "text", valueKey: "valueChar" },
      { id: "LogoSourceDarkMode", type: "text", valueKey: "valueChar" },
      { id: "TopBarLogoSourceWhiteMode", type: "text", valueKey: "valueChar" },
      { id: "TopBarLogoSourceDarkMode", type: "text", valueKey: "valueChar" },
    ],
  },
  {
    label: "System",
    params: [
      { id: "AutoLogOutTime", type: "number", valueKey: "valueNum" },
      { id: "AgreementsVersion", type: "number", valueKey: "valueNum" },
      { id: "DataMaintenance", type: "boolean", valueKey: "valueBool" },
      { id: "WorkingSaturday", type: "boolean", valueKey: "valueBool" },
      { id: "WorkingSunday", type: "boolean", valueKey: "valueBool" },
    ],
  },
  {
    label: "Produkty i wyszukiwanie",
    params: [
      { id: "DefaultProductsSortColumn", type: "text", valueKey: "valueChar" },
      { id: "BasketItemsCountLimit", type: "number", valueKey: "valueNum" },
      { id: "EanMaskRegExpr", type: "text", valueKey: "valueChar" },
      { id: "IndexMask", type: "text", valueKey: "valueChar" },
      { id: "IndexMaskRegExpr", type: "text", valueKey: "valueChar" },
      {
        id: "ProductFiltersDebounceTimeout",
        type: "number",
        valueKey: "valueNum",
      },
      { id: "SearchingQueryCharNumber", type: "number", valueKey: "valueNum" },
      { id: "SearchingQueryDelay", type: "number", valueKey: "valueNum" },
      { id: "SearchingQueryMethod", type: "number", valueKey: "valueNum" },
      {
        id: "SearchingQueryStartLikeFirst",
        type: "boolean",
        valueKey: "valueBool",
      },
      {
        id: "SearchingQueryStartLikeMax",
        type: "number",
        valueKey: "valueNum",
      },
      {
        id: "SearchingQueryMaskRegExpr",
        type: "textarea",
        valueKey: "valueText",
      },
    ],
  },
  {
    label: "Dostępność",
    params: [
      { id: "AvailabilityCutoffTime", type: "time", valueKey: "valueChar" },
      { id: "AvailabilityLevel1Desc", type: "text", valueKey: "valueChar" },
      {
        id: "AvailabilityLevel2BeforeDesc",
        type: "text",
        valueKey: "valueChar",
      },
      {
        id: "AvailabilityLevel2AfterDesc",
        type: "text",
        valueKey: "valueChar",
      },
      {
        id: "AvailabilityLevel3BeforeDesc",
        type: "text",
        valueKey: "valueChar",
      },
      {
        id: "AvailabilityLevel3AfterDesc",
        type: "text",
        valueKey: "valueChar",
      },
      { id: "SupplierStockDesc", type: "text", valueKey: "valueChar" },
    ],
  },
  {
    label: "Email i SMTP",
    params: [
      { id: "EmailSending", type: "boolean", valueKey: "valueBool" },
      { id: "SMTPHost", type: "text", valueKey: "valueChar" },
      { id: "SMTPPort", type: "number", valueKey: "valueNum" },
      { id: "SMTPEmail", type: "email", valueKey: "valueChar" },
      { id: "SMTPLogin", type: "text", valueKey: "valueChar" },
      { id: "SMTPPassword", type: "password", valueKey: "valueChar" },
      { id: "SMTPEnableSSL", type: "boolean", valueKey: "valueBool" },
    ],
  },
  {
    label: "AI",
    params: [
      { id: "AIDescriptionIsActive", type: "boolean", valueKey: "valueBool" },
      { id: "AIModel", type: "text", valueKey: "valueChar" },
      { id: "OpenRouterApiKey", type: "password", valueKey: "valueChar" },
    ],
  },
  {
    label: "Płatności",
    params: [
      { id: "PaymentDataProcessing", type: "boolean", valueKey: "valueBool" },
      { id: "PaymentStatusRetrieving", type: "boolean", valueKey: "valueBool" },
      { id: "ElavonPaymentReturnUrl", type: "url", valueKey: "valueChar" },
    ],
  },
  {
    label: "Integracja Ferrodo",
    params: [
      { id: "FerrodoEhandelApiAddress", type: "url", valueKey: "valueChar" },
      { id: "FerrodoEhandelApiLogin", type: "text", valueKey: "valueChar" },
      {
        id: "FerrodoEhandelApiPassword",
        type: "password",
        valueKey: "valueChar",
      },
      { id: "FerrodoGusApiAddress", type: "url", valueKey: "valueChar" },
      { id: "EhandelAcceptOfferUrl", type: "url", valueKey: "valueChar" },
      { id: "EhandelArticlePhotoUrl", type: "url", valueKey: "valueChar" },
      { id: "EhandelProductUrl", type: "url", valueKey: "valueChar" },
      { id: "GeolocationApiKey", type: "password", valueKey: "valueChar" },
    ],
  },
  {
    label: "Foldery i pliki",
    params: [
      { id: "CustomerDataFolder", type: "text", valueKey: "valueChar" },
      { id: "DocumentDataFolder", type: "text", valueKey: "valueChar" },
      { id: "OrderDataFolder", type: "text", valueKey: "valueChar" },
    ],
  },
  {
    label: "Kopiowanie danych",
    params: [
      { id: "CopyDataLogin", type: "text", valueKey: "valueChar" },
      { id: "CopyDataPassword", type: "password", valueKey: "valueChar" },
      {
        id: "MaxAttemptsCopyDataFromBuffer",
        type: "number",
        valueKey: "valueNum",
      },
    ],
  },
  {
    label: "Bezpieczeństwo i hasła",
    params: [
      { id: "PasswordValidityTime", type: "number", valueKey: "valueNum" },
      {
        id: "PasswordResetLinkActivityTime",
        type: "number",
        valueKey: "valueNum",
      },
    ],
  },
  {
    label: "Cennik i oferty",
    params: [
      { id: "PriceListSending", type: "boolean", valueKey: "valueBool" },
      { id: "PriceListExportMaxArticle", type: "number", valueKey: "valueNum" },
      {
        id: "MinutesSinceEndPriceListTask",
        type: "number",
        valueKey: "valueNum",
      },
      { id: "OfferCustomerSending", type: "boolean", valueKey: "valueBool" },
      { id: "OrderWhIdList", type: "text", valueKey: "valueChar" },
    ],
  },
  {
    label: "Zgody marketingowe",
    params: [
      { id: "MarketingAgreementText", type: "textarea", valueKey: "valueChar" },
      {
        id: "MarketingByElectronicMeansText",
        type: "textarea",
        valueKey: "valueChar",
      },
    ],
  },
];

// Płaska lista wszystkich id do jednorazowego fetch z API
export const ALL_PARAM_IDS = PARAM_GROUPS.flatMap((g) =>
  g.params.map((p) => p.id),
);
